var React = require('react');

function EllipsisH (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 184a72 72 0 1 0 72 72 72 72 0 0 0-72-72z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M432 184a72 72 0 1 0 72 72 72 72 0 0 0-72-72zm-352 0a72 72 0 1 0 72 72 72 72 0 0 0-72-72z","className":"fa-primary","key":2})]);
}

EllipsisH.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = EllipsisH;

EllipsisH.default = EllipsisH;
